"use client";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useLanguage } from "@/context/LanguageContext";

export default function WhatIsWatchDog() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      label: "Hlídací pes",
      title: "Co je Hlídací pes na nemovitosti?",
      subtitle:
        "Automatická služba, která nepřetržitě sleduje realitní trh za vás a upozorní vás jako první, když se objeví ta pravá nabídka.",
      cards: [
        {
          eyebrow: "Rychlost rozhoduje",
          title: "Realitní trh nikdy nespí",
          text: "Nejlepší nemovitosti se prodají během hodin. Ruční procházení inzerátů každý den je zdlouhavé a stejně stihnete jen zlomek nabídek. Hlídací pes to dělá za vás - nepřetržitě, automaticky, 24 hodin denně.",
        },
        {
          eyebrow: "Plná kontrola",
          title: "Vy rozhodujete, my hlídáme",
          text: "Nastavíte přesná kritéria jednou - lokalitu, cenu, dispozici nebo stav nemovitosti - a systém pracuje za vás. Žádné zbytečné notifikace, jen relevantní nabídky přesně podle vašich požadavků.",
        },
        {
          eyebrow: "Náskok před ostatními",
          title: "Buďte první na trhu",
          text: "Atraktivní nemovitosti v Praze, Brně i dalších městech mizí z trhu během prvních hodin. S hlídacím psem dostanete upozornění okamžitě po přidání nového inzerátu - dříve než ostatní zájemci.",
        },
        {
          eyebrow: "Přehled o trhu",
          title: "Sledujte vývoj cen nemovitostí",
          text: "Hlídací pes nezapomíná. Sleduje historii cen inzerátů a upozorní vás, když prodejce cenu sníží. Získáte přehled o vývoji cen ve vámi sledované lokalitě.",
        },
      ],
    },
    en: {
      label: "WatchDog",
      title: "What is a property watchdog?",
      subtitle:
        "An automated service that monitors the real estate market for you nonstop and alerts you first when the right listing appears.",
      cards: [
        {
          eyebrow: "Speed matters",
          title: "The real estate market never sleeps",
          text: "The best properties sell within hours. Manually checking listings every day is slow and you still only catch a fraction of them. The watchdog does it for you - continuously, automatically, 24 hours a day.",
        },
        {
          eyebrow: "Full control",
          title: "You decide, we monitor",
          text: "Set exact criteria once - location, price, layout, or property condition - and the system works for you. No unnecessary notifications, only relevant listings that match your needs.",
        },
        {
          eyebrow: "Ahead of others",
          title: "Be first on the market",
          text: "Attractive properties in Prague, Brno, and other cities disappear in the first hours. With the watchdog you get an alert immediately after a new listing appears - before other buyers.",
        },
        {
          eyebrow: "Market overview",
          title: "Track property price development",
          text: "The watchdog remembers. It tracks listing price history and alerts you when the seller lowers the price. You gain a clear view of price movement in your selected location.",
        },
      ],
    },
  }[language];

  return (
    <div className="about3-root">
      <div className="watchdog-text-root">
        <span className="section-label">{copy.label}</span>
        <h2 className="section-title">{copy.title}</h2>
        <p className="section-subtitle">{copy.subtitle}</p>
      </div>

      <div className="watchdog-pitch-grid">
        {copy.cards.map((card) => (
          <div key={card.title} className="watchdog-pitch-card">
            <p className="watchdog-pitch-eyebrow">{card.eyebrow}</p>
            <h3 className="watchdog-pitch-title">{card.title}</h3>
            <p className="watchdog-pitch-text">{card.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
